exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@page{size:A4;margin:5mm -20mm 5mm -20mm!important}@media print{body *{visibility:hidden}.non-print{display:none}#ShowRolesModal,#ShowRolesModal *{visibility:visible}#ShowRolesModal,#ShowRolesModal *{overflow:visible!important;-webkit-print-color-adjust:exact}#ShowRolesModal{position:absolute;left:0;top:0;width:100%!important;height:100%}}", ""]);

// exports
